import * as React from 'react';
import IImage from '../../Entities/Image';
import Image from '../Image/Image';

const MIN_PARALLAX_WIDTH = 768;

export interface Props {
  image: IImage;
  getHeight?: (height: number) => void;
}

export interface State {
  scrollValue: number;
}

export default class extends React.PureComponent<Props, State> {
  private imageElement: HTMLElement;

  constructor(props: Props) {
    super(props);
    this.state = { scrollValue: 0 };
    this.handleResize = this.handleResize.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
  }

  public render() {
    return (
      <Image
        {...this.props.image}
        // tslint:disable-next-line:jsx-no-lambda
        getRef={(element: HTMLElement) => (this.imageElement = element)}
        scrollValue={this.state.scrollValue}
        fixed={true}
      />
    );
  }

  public componentDidMount() {
    if (this.props.getHeight) {
      this.handleResize(); // Initial load
      this.handleScroll(); // Initial load
      window.addEventListener('resize', this.handleResize);
      window.addEventListener('scroll', this.handleScroll);
    }
  }

  public componentWillUnmount() {
    if (this.props.getHeight) {
      window.removeEventListener('resize', this.handleResize);
      window.removeEventListener('scroll', this.handleScroll);
    }
  }

  private handleResize() {
    if (this.props.getHeight) {
      this.props.getHeight(this.height);
    }
  }

  private handleScroll() {
    if (window.innerWidth < MIN_PARALLAX_WIDTH) {
      if (this.state.scrollValue !== 0) {
        this.setState({ scrollValue: 0 });
      }
      return;
    }
    const scrollValue = window.scrollY / 2 * -1; // Half the scroll and inverted
    this.setState({ scrollValue });
  }

  get height(): number {
    return this.imageElement.offsetHeight;
  }
}



// WEBPACK FOOTER //
// ./src/components/Cover/Cover.tsx